export const ACTUALIZAR_DISTRIBUCIONES = "ACTUALIZAR_DISTRIBUCIONES";
export const ACTUALIZAR_DISTRIBUCIONES_DB = "ACTUALIZAR_DISTRIBUCIONES_DB";
export const CARGANDO_DIST = "CARGANDO_DIST";
export const ERROR_DIST = "ERROR_DIST";
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";
